import { toast as r } from "@systemeio/ui";
import { createHttpClient as o, getUseBaseFetch as s, getErrorMapper as n } from "@systemeio/util";
const t = o();
t.interceptors.response.use((e) => e, n(t));
const a = s({
  httpClient: t,
  useRouter: () => ({
    push: async (e) => (window.location.assign(e), !0),
    replace: async (e) => (window.location.replace(e), !0)
  }),
  toast: r
});
export {
  t as httpClient,
  a as useFetch
};
